import toast from 'react-hot-toast';

// Estilos personalizados para os toasts
const toastStyles = {
  success: {
    duration: 4000,
    style: {
      background: '#10b981',
      color: '#ffffff',
      fontWeight: '500',
      borderRadius: '0.5rem',
      padding: '12px 16px',
      fontSize: '14px',
      boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    },
    iconTheme: {
      primary: '#ffffff',
      secondary: '#10b981',
    },
  },
  error: {
    duration: 5000,
    style: {
      background: '#ef4444',
      color: '#ffffff',
      fontWeight: '500',
      borderRadius: '0.5rem',
      padding: '12px 16px',
      fontSize: '14px',
      boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    },
    iconTheme: {
      primary: '#ffffff',
      secondary: '#ef4444',
    },
  },
  loading: {
    style: {
      background: '#3b82f6',
      color: '#ffffff',
      fontWeight: '500',
      borderRadius: '0.5rem',
      padding: '12px 16px',
      fontSize: '14px',
      boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    },
    iconTheme: {
      primary: '#ffffff',
      secondary: '#3b82f6',
    },
  },
  default: {
    duration: 4000,
    style: {
      background: '#ffffff',
      color: '#1f2937',
      fontWeight: '500',
      borderRadius: '0.5rem',
      padding: '12px 16px',
      fontSize: '14px',
      border: '1px solid #e5e7eb',
      boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    },
  },
};

export const useToast = () => {
  const success = (message: string) => {
    toast.success(message, toastStyles.success);
  };

  const error = (message: string) => {
    toast.error(message, toastStyles.error);
  };

  const loading = (message: string) => {
    return toast.loading(message, toastStyles.loading);
  };

  const info = (message: string) => {
    toast(message, toastStyles.default);
  };

  const dismiss = (toastId?: string) => {
    if (toastId) {
      toast.dismiss(toastId);
    } else {
      toast.dismiss();
    }
  };

  // Função para atualizar um toast de loading
  const promise = <T,>(
    promise: Promise<T>,
    msgs: {
      loading: string;
      success: string | ((data: T) => string);
      error: string | ((error: any) => string);
    }
  ) => {
    return toast.promise(promise, msgs, {
      loading: toastStyles.loading,
      success: toastStyles.success,
      error: toastStyles.error,
    });
  };

  return {
    success,
    error,
    loading,
    info,
    dismiss,
    promise,
  };
};

// Export individual functions for convenience (similar to Sonner API)
export const showSuccess = (message: string) => {
  toast.success(message, toastStyles.success);
};

export const showError = (message: string) => {
  toast.error(message, toastStyles.error);
};

export const showLoading = (message: string) => {
  return toast.loading(message, toastStyles.loading);
};

export const showInfo = (message: string) => {
  toast(message, toastStyles.default);
};